/** Query / session helpers for Connected Services OAuth return. */

export const CP_CONNECTED_PARAM = "cp_connected";
export const CP_CONNECTED_RESULT_PARAM = "cp_connected_result";
export const CP_CONNECTED_ERROR_PARAM = "cp_connected_error";
export const CP_OAUTH_RETURN_SCREEN_KEY = "cp_connected_service_oauth_return";

export function markConnectedServiceOAuthReturn(screenKey = "user_preferences") {
  try {
    sessionStorage.setItem(CP_OAUTH_RETURN_SCREEN_KEY, screenKey);
  } catch {
    // ignore
  }
}

export function consumeConnectedServiceOAuthReturnScreen() {
  try {
    const value = sessionStorage.getItem(CP_OAUTH_RETURN_SCREEN_KEY);
    sessionStorage.removeItem(CP_OAUTH_RETURN_SCREEN_KEY);
    return value;
  } catch {
    return null;
  }
}

/**
 * @returns {{ serviceId: string, result: string, error: string|null } | null}
 */
export function readConnectedServiceOAuthReturnParams(search = window.location.search) {
  const params = new URLSearchParams(search);
  const serviceId = params.get(CP_CONNECTED_PARAM);
  if (!serviceId) {
    return null;
  }
  return {
    serviceId,
    result: params.get(CP_CONNECTED_RESULT_PARAM) || "success",
    error: params.get(CP_CONNECTED_ERROR_PARAM),
  };
}

export function clearConnectedServiceOAuthReturnParams() {
  const url = new URL(window.location.href);
  url.searchParams.delete(CP_CONNECTED_PARAM);
  url.searchParams.delete(CP_CONNECTED_RESULT_PARAM);
  url.searchParams.delete(CP_CONNECTED_ERROR_PARAM);
  window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
}
